export default "__VITE_ASSET__57380ca8__"